<template>
  <div>
    <CRow>
      <CCol md="12" class="mb-5">

        <CRow>
          <CCol col="3">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('General') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon name="saveNew" @click.native="insert_bussiness()"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <!--                <CRow form class="form-group">-->
                <!--                  <CCol tag="label" sm="5" class="col-form-label">-->
                <!--                    {{ $t('YearEnd') }}-->
                <!--                  </CCol>-->
                <!--                  <CCol sm="7">-->
                <!--                    <date-picker v-if="$i18n.locale=='fa'"-->
                <!--                                 type="year"-->
                <!--                                 display-format="jYYYY"-->
                <!--                                 format="YYYY"-->
                <!--                                 v-model="bussiness_public.AccountYear"-->
                <!--                    ></date-picker>-->
                <!--                    <date-picker v-else-->
                <!--                                 type="year"-->
                <!--                                 display-format="YYYY"-->
                <!--                                 format="YYYY"-->
                <!--                                 v-model="bussiness_public.AccountYear"-->
                <!--                    ></date-picker>-->

                <!--                  </CCol>-->
                <!--                </CRow>-->
                <!--                <CRow form class="form-group">-->
                <!--                  <CCol tag="label" sm="5" class="col-form-label">-->
                <!--                    {{ $t('StartOfYear') }}-->
                <!--                  </CCol>-->
                <!--                  <CCol sm="7">-->
                <!--                    <date-picker-->
                <!--                        v-model="bussiness_public.StartAccountYear"-->

                <!--                    ></date-picker>-->
                <!--                  </CCol>-->
                <!--                </CRow>-->
                <!--                <CRow form class="form-group">-->
                <!--                  <CCol tag="label" sm="5" class="col-form-label">-->
                <!--                    {{ $t('EndOfYear') }}-->
                <!--                  </CCol>-->
                <!--                  <CCol sm="7">-->
                <!--                    <date-picker-->
                <!--                        v-model="bussiness_public.EndAccountYear"-->

                <!--                    ></date-picker>-->
                <!--                  </CCol>-->
                <!--                </CRow>-->
                <!--              -->
<!--                <CInput-->
<!--                    :label="$t('VAT')"-->
<!--                    :value.sync="bussiness_public.Vat"-->
<!--                    append="%"-->
<!--                    addInput-->
<!--                    addInputClasses="text-end"-->
<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                />-->
                <CInput
                    :label="$t('VATNumber')"
                    :value.sync="bussiness_public.AccountYear"

                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />

                <CRow form class="form-group">
                  <CCol tag="label" sm="5" class="col-form-label">
                    {{ $t('VATDate') }}
                  </CCol>
                  <CCol sm="7">
                    <date-picker
                        v-model="bussiness_public.StartAccountYear"

                    ></date-picker>
                  </CCol>
                </CRow>
                <CInput
                    :label="$t('economicalCode')"
                    :value.sync="bussiness_public.EconomicCode"

                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CRow form class="form-group">
                  <CCol tag="label" sm="5" class="col-form-label">
                    {{ $t('economicalDate') }}
                  </CCol>
                  <CCol sm="7">
                    <date-picker
                        v-model="bussiness_public.EconomicCodeDate"

                    ></date-picker>
                  </CCol>
                </CRow>
                <CInput
                    :label="$t('nightJob')"
                    :value.sync="bussiness_public.NightJob"
                    append="%"
                    addInputClasses="text-end"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                ></CInput>
                <CInput
                    :label="$t('holidayJob')"
                    :value.sync="bussiness_public.HollidayJob"
                    append="%"
                    addInputClasses="text-end"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    :label="$t('extraJob')"
                    :value.sync="bussiness_public.UpperJob"
                    append="%"
                    addInputClasses="text-end"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CSelect
                        v-if="get_access('auto_accounting')"
                    :label="$t('AutoAccounting')"
                    :value.sync="bussiness_public.AccountingAuto"
                    :options="[{label:$t('components.statusOn'),value:1},{label:$t('components.statusOff'),value:0}]"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />

                <CInputCurrency
                        v-if="get_access('minFactorPrice')"
                        :label="$t('minFactorPrice')"
                        :value.sync="bussiness_public.floorPrice"
                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />

              </CCardBody>
            </CCard>
          </CCol>

          <CCol class="p-0">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('Regional') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon name="saveNew" @click.native="insert_currencies()"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <CInput
                    :label="$t('CurrencySymbol')"
                    :value.sync="bussiness_currencies.Symbol"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                />
                <CInput
                    :label="$t('CurrencyName')"
                    :value.sync="bussiness_currencies.Currency"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                />
                <!--                                <CInput-->
                <!--                                        :label="$t('CurrencyOrder')"-->
                <!--                                        :value.sync="bussiness_currencies.CurrencyOrder"-->
                <!--                                        :horizontal="{label: 'col-sm-7', input: 'col-sm-5'}"-->
                <!--                                />-->
                <CSelect
                    :options="[{label:'£10',value:0},{label:'£10.00',value:2},{label:'£10.000',value:3}]"
                    :label="$t('CurrencyDigits')"
                    :value.sync="bussiness_currencies.CurrencyDigits"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                />
                <CSelect
                    :options="[
                                    'YYYY/MM/DD',
                                    'DD/MM/YYYY',
                                    ]"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                    :label="$t('dateFormat')"
                    :value.sync="date_format"
                />
                <!--                                <CInput-->
                <!--                                        :label="$t('DecimalSymbol')"-->
                <!--                                        :value.sync="bussiness_currencies.Decimal"-->
                <!--                                        :horizontal="{label: 'col-sm-7', input: 'col-sm-5'}"-->
                <!--                                />-->
                <!--                                <CInput-->
                <!--                                        :label="$t('ThousandSymbol')"-->
                <!--                                        :value.sync="bussiness_currencies.Thousands"-->
                <!--                                        :horizontal="{label: 'col-sm-7', input: 'col-sm-5'}"-->
                <!--                                />-->
                <!--                                <CInput-->
                <!--                                        :label="$t('Language')"-->
                <!--                                        :value.sync="bussiness_currencies.Language"-->
                <!--                                        :horizontal="{label: 'col-sm-7', input: 'col-sm-5'}"-->
                <!--                                />-->


              </CCardBody>
            </CCard>

          </CCol>

          <CCol>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('banks') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon name="saveNew" @click.native="insert_bank()"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody class="text-center">
                <CRow>
                  <CCol>
                    <CInput
                        :placeholder="$t('name')"
                        v-model="new_bank_name"
                    />
                  </CCol>
                </CRow>
                <CDataTable
                    :items="bank_items"
                    :fields="fields_banks_names"
                    striped
                    border
                    :items-per-page="20"
                    hover
                    pagination
                >
                  <template #row="{item}">

                    <td style="text-align: center">

                      <p>{{ item.row_id + 1 }}</p>

                    </td>

                  </template>

                  <template #operation="{item,index}">
                    <td>

                      <CButton

                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="edit_bank_name(item)"
                      >
                        <CIcon size="sm" class="text-dark" name="cil-pencil"/>
                      </CButton>

                    </td>
                  </template>


                </CDataTable>

              </CCardBody>
            </CCard>

          </CCol>
          <CCol col="4">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('FiscalYear') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon name="saveNew" @click.native="insert_year()"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody class="text-center">
                <CRow>
                  <CCol col="6">
                    <CRow form class="form-group">
<!--                      <CCol tag="label" sm="5" class="col-form-label">-->
                        {{ $t('name') }}
<CInput  v-model="AccountYear"/>
<!--                        <date-picker v-if="$i18n.locale=='fa'"-->
<!--                                     type="year"-->
<!--                                     display-format="jYYYY"-->
<!--                                     format="YYYY"-->
<!--                                     v-model="AccountYear"-->
<!--                        ></date-picker>-->
<!--                        <date-picker v-else-->
<!--                                     type="year"-->
<!--                                     display-format="YYYY"-->
<!--                                     format="YYYY"-->
<!--                                     v-model="AccountYear"-->
<!--                        ></date-picker>-->

<!--                      </CCol>-->
                    </CRow>

                  </CCol>
                  <CCol col="6">


                  </CCol>
                  <CCol col="6">

                    <CRow form class="form-group">
                      {{ $t('StartOfYear') }}
                      <date-picker
                          v-model="StartAccountYear"

                      ></date-picker>
                    </CRow>
                  </CCol>
                  <CCol col="6">
                    <CRow form class="form-group">
                      {{ $t('EndOfYear') }}
                      <date-picker
                          v-model="EndAccountYear"

                      ></date-picker>
                    </CRow>
                  </CCol>
                </CRow>
                <CDataTable
                    :items="year_items"
                    :fields="fields_years"
                    striped
                    border
                    :items-per-page="20"
                    hover
                    pagination
                >
                  <template #row="{item}">
                    <td style="text-align: center">
                      <p>{{ item.row_id + 1 }}</p>
                    </td>
                  </template>
                  <template #startYear="{item}">
                    <td style="text-align: center">
                      <p>{{ get_date(item.startYear) }}</p>
                    </td>
                  </template>
                  <template #endDate="{item}">
                    <td style="text-align: center">
                      <p>{{ get_date(item.endDate) }}</p>
                    </td>
                  </template>
                  <template #title="{item}">
                    <td style="text-align: center">
                      <p>{{ get_year(item.title) }}</p>
                    </td>
                  </template>
                  <template #isActive="{item}">
                    <td style="text-align: center">
                      <CIcon @click.native="is_active_year(item)"
                             v-if="item.isActive==1" class="text-success" name="cil-check"/>
                      <CIcon @click.native="is_active_year(item)" v-else name="cil-check"/>

<!--                      <p v-if="item.isActive==1">{{ $t('active') }}</p>-->
<!--                      <p v-if="item.isActive==0">{{ $t('deactivate') }}</p>-->
                    </td>
                  </template>

                  <template #operation="{item,index}">
                    <td>

                      <CButton

                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="edit_year_name(item)"
                      >
                        <CIcon size="sm" class="text-dark" name="cil-pencil"/>
                      </CButton>
                      <CButton
                          square
                          :title="$t('buttons.delete')"
                          size="sm"
                          @click="delete_item_dialog_year(item)"
                      >
                        <CIcon size="sm" class="text-danger" name="cil-trash"/>
                      </CButton>

                    </td>
                  </template>


                </CDataTable>

              </CCardBody>
            </CCard>

          </CCol>


        </CRow>

      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items = [];
import Vue from 'vue';

export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      date_format: 'YYYY/MM/DD',
      name: '',
      file: null,
      color: '#ffffff',
      code: '',
      previewImage: '/img/placeholder.png',
      description: '',
      phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
      fields_banks: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'bankAccTitle', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        // {key: 'bankName', label: this.$t('tables.bank'), _style: 'width:10%'},
        // {key: 'bankAccCode', label: this.$t('tables.bankAccCode'), _style: 'width:10%'},
        // {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
        // {key: 'shabaNo', label: this.$t('tables.shabaNo'), _style: 'width:10%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      bank_items: [],
      items_banks: [],
      year_items: [],
      AccountYear: '',
      StartAccountYear: '',
      EndAccountYear: '',
      yearActive: 0,
      status_year: 0,
      fields_years: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'title', label: this.$t('name'), _style: 'width:10%'},
        {key: 'startYear', label: this.$t('StartOfYear'), _style: 'width:10%'},
        {key: 'endDate', label: this.$t('EndOfYear'), _style: 'width:10%'},
        {key: 'isActive', label: this.$t('tables.status'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%'},


      ],
      fields_cash: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'boxTitle', label: this.$t('tables.name'), _style: 'width:10%'},

      ],
      bussiness_currencies: {CurrencyDigits: 2},
      bussiness_public: {},

      unit_modir: null,
      unit_modir_name: null,
      unit_modir_id: null,
      unit_modir_search: true,
      unit_modir_options: [],


      ejraii_modir: null,
      ejraii_modir_name: null,
      ejraii_modir_id: null,
      ejraii_modir_search: true,
      ejraii_modir_options: [],

      modir_asli: null,
      modir_asli_name: null,
      modir_asli_id: null,
      modir_asli_search: true,
      modir_asli_options: [],

      new_bank_name: '',
      bank_status_form: 0,
      items_warehouse: [],
      items_accounting: [],
      items_accounting_groups: [],
      items_accounting_list: [],
      items_accounting_sub_groups: [],
      fields_coding: [
        // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},

        {key: 'titleFA', label: this.$t('title'), _style: 'width:20%;'},
        {key: 'prefixOrLenght', label: this.$t('Prefix'), _style: 'width:10%'},

        {key: 'value', label: this.$t('tables.value'), _style: 'width:40%;'},
        // {key: 'valueType', label: 'valueType', _style: 'width:20%;'},
        // {key: 'module', label: 'module', _style: 'width:20%;'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:2%;'},


      ],
      fields_coding_product: [
        // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},

        {key: 'titleFA', label: this.$t('title'), _style: 'width:30%;'},
        {key: 'prefixOrLenght', label: this.$t('length'), _style: 'width:10%'},

        {key: 'value', label: this.$t('tables.value'), _style: 'width:20%;'},
        // {key: 'valueType', label: 'valueType', _style: 'width:20%;'},
        // {key: 'module', label: 'module', _style: 'width:20%;'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:2%;'},


      ],
      fields_banks_names: [
        // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'row', label: this.$t('row'), _style: 'width:5%;'},
        {key: 'bankTitle', label: this.$t('name'), _style: 'width:20%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:2%;'},
      ],
      items_cash: [],

      details: [],
      collapseDuration: 0,
      status_form: 0,
      status_form_year: 0,
      load_persons({action, searchQuery, callback}) {
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_bussiness();
    this.get_currencies();
    this.get_system_users();
    this.get_bank();
    this.get_years();
    this.get_lists();
    this.get_lists_groups();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on(this.confirm_delete_name+"_delete_year", (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item_year();

      } else {
        this.status_form_year = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    is_active_year(item){
      this.change_status_year(item,1)

//       for(var i=0;i<this.year_items.length;i++){
//        if(this.year_items[i].id == item.id) {
//          this.change_status_year(this.year_items[i], 1)
// Vue.set(this.year_items[i],'isActive',1)
//        }else{
//          this.change_status_year(this.year_items[i],0)
//          Vue.set(this.year_items[i],'isActive',0)
//
//        }
//        }

    },
    select_modir_user(type, node) {
      console.log("select user", type, node);
      if (type == 1) {//vahed
        this.unit_modir_name = node.userName;
      }
      if (type == 2) {//ejraii
        this.ejraii_modir_name = node.userName;
      }
      if (type == 3) {//modiriat
        this.modir_asli_name = node.userName;
      }
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.previewImage != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.previewImage == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertImage'));
      }
      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    get_bank() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_bank_name(item) {
      this.new_bank_name = item.bankTitle;
      this.bank_status_form = item.id;
    },
    insert_bank() {
      var self = this;

      const formData = new FormData();


      var url = '';
      if (this.bank_status_form == 0) {
        url = 'AddBank';
      } else {
        url = 'EditBank';
        formData.append('id', this.bank_status_form);

      }
      formData.append('BankTitle', this.new_bank_name);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        self.new_bank_name = ''
        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);
        self.get_bank();
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_years() {
      var self = this;

      const formData = new FormData();
      // formData.append('id', this.selected_province);
      axios.post('GetFiscalYears', formData, {}).then(function (response) {


        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.year_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
         var current_year =  self.year_items.filter(x=>x.isActive==1)[0]
          console.log("year closed ",current_year.closed)
          localStorage.setItem("year_opened",current_year.opened)
          localStorage.setItem("year_closed",current_year.closed)
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_year_name(item) {
      this.yearActive = item.isActive;
      this.AccountYear = item.title;
      this.StartAccountYear = item.startYear;
      this.EndAccountYear = item.endDate;
      this.status_year = item.id;
    },
    insert_year() {
      var self = this;

      const formData = new FormData();

      var url = '';
      if (this.status_year == 0) {
        url = 'AddFiscalYear';
      } else {
        url = 'EditFiscalYear';
        formData.append('id', this.status_year);
      }
      formData.append('Title', this.AccountYear);
      formData.append('StartYear', this.StartAccountYear);
      formData.append('EndDate', this.EndAccountYear);
      formData.append('IsActive', this.yearActive);


      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        self.new_bank_name = ''
        if(response.data.statusCode==0){
          self.status_year=0;
          self.AccountYear = ''
          self.StartAccountYear= ''
          self.EndAccountYear= ''
        }
        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);
        self.get_years();
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    change_status_year(item,active) {
      var self = this;

      const formData = new FormData();

      var url = '';

        url = 'ChangeActiveYear';
        formData.append('id', item.id);

      // formData.append('Title', item.title);
      // formData.append('StartYear', item.startYear);
      // formData.append('EndDate', item.endDate);
      // formData.append('IsActive', active);
      //

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // self.new_bank_name = ''
        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);
        self.get_years();
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog_year(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name+"_delete_year");

      this.status_form_year = item.id;

    }, delete_item_year() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFiscalYear";


      formData.append('Id', this.status_form_year);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form_year = 0;

        self.get_years();


      })
              .catch(function (error) {

                console.log(error);
              });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_cash = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_bussiness() {

      let self = this;
      const formData = new FormData();
      let url = "AddBusinessPublic";




      formData.append('vatNumber', this.bussiness_public.AccountYear);
      formData.append('vatDate', this.bussiness_public.StartAccountYear);
      formData.append('EndAccountYear', this.bussiness_public.EndAccountYear);
      formData.append('Vat', this.bussiness_public.Vat);
      formData.append('EconomicCode', this.bussiness_public.EconomicCode);
      formData.append('EconomicCodeDate', this.bussiness_public.EconomicCodeDate);
      formData.append('NightJob', this.bussiness_public.NightJob);
      formData.append('HollidayJob', this.bussiness_public.HollidayJob);
      formData.append('UpperJob', this.bussiness_public.UpperJob);
      formData.append('AccountingAuto', this.bussiness_public.AccountingAuto);
      formData.append('FloorPrice', this.bussiness_public.floorPrice.toString().replace(/,/g, ''));

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

      }).catch(function (error) {
        console.log(error);
      });

    },
    get_bussiness() {

      let self = this;
      const formData = new FormData();
      let url = "GetBusinessPublic";

      axios.post(url, formData, {}).then((res) => {
        self.bussiness_public.AccountYear = ''
        self.bussiness_public.StartAccountYear = ''
        self.bussiness_public.EndAccountYear = ''
        self.bussiness_public.Vat = ''
        self.bussiness_public.EconomicCode = ''
        self.bussiness_public.EconomicCodeDate = ''
        self.bussiness_public.NightJob = ''
        self.bussiness_public.HollidayJob = ''
        self.bussiness_public.UpperJob = ''
        self.bussiness_public.AccountingAuto = 1
        self.bussiness_public.vatNumber = ''
        self.bussiness_public.vatDate = ''
        self.bussiness_public.floorPrice = ''
        if (res.data.data.accountYear != null) {
          var data2 = res.data.data

          self.bussiness_public.AccountYear = data2.accountYear
          self.bussiness_public.StartAccountYear = data2.startAccountYear
          self.bussiness_public.EndAccountYear = data2.endAccountYear
          self.bussiness_public.Vat = data2.vat
          self.bussiness_public.EconomicCode = data2.economicCode
          self.bussiness_public.EconomicCodeDate = data2.economicCodeDate
          self.bussiness_public.NightJob = data2.nightJob
          self.bussiness_public.HollidayJob = data2.hollidayJob
          self.bussiness_public.UpperJob = data2.upperJob
          self.bussiness_public.AccountingAuto = data2.accountingAuto
          self.bussiness_public.vatNumber = data2.vatNumber
          self.bussiness_public.vatDate = data2.vatDate
          self.bussiness_public.floorPrice = data2.floorPrice
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    insert_currencies() {

      let self = this;
      const formData = new FormData();
      let url = "AddBusinessCurrency";

      formData.append('Symbol', this.bussiness_currencies.Symbol);
      formData.append('Currency', this.bussiness_currencies.Currency);
      formData.append('CurrencyOrder', this.bussiness_currencies.CurrencyOrder);
      formData.append('CurrencyDigits', this.bussiness_currencies.CurrencyDigits);
      formData.append('Decimal', this.bussiness_currencies.Decimal);
      formData.append('Thousands', this.bussiness_currencies.Thousands);
      formData.append('Language', this.bussiness_currencies.Language);
      formData.append('DateFormat', this.date_format);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        localStorage.setItem('currency_symbol', self.bussiness_currencies.Symbol);
        localStorage.setItem('currency_digits', self.bussiness_currencies.CurrencyDigits);
        localStorage.setItem('setting_date_format', self.date_format);

      }).catch(function (error) {
        console.log(error);
      });

    },
    get_currencies() {

      let self = this;
      const formData = new FormData();
      let url = "GetBusinessCurrency";

      axios.post(url, formData, {}).then((res) => {
        self.bussiness_currencies.Symbol = ''
        self.bussiness_currencies.Currency = ''
        self.bussiness_currencies.CurrencyOrder = ''
        self.bussiness_currencies.CurrencyDigits = 0
        self.bussiness_currencies.Decimal = ''
        self.bussiness_currencies.Thousands = ''
        self.bussiness_currencies.Language = ''

        if (res.data.data.symbol != null) {
          var data2 = res.data.data
          self.bussiness_currencies.Symbol = data2.symbol
          self.bussiness_currencies.Currency = data2.currency
          self.bussiness_currencies.CurrencyOrder = data2.currencyOrder
          // Vue.set(self.bussiness_currencies,'CurrencyDigits',data2.currencyDigits)
          self.bussiness_currencies.CurrencyDigits = parseInt(data2.currencyDigits)
          self.bussiness_currencies.Decimal = data2.decimal
          self.bussiness_currencies.Thousands = data2.thousands
          self.bussiness_currencies.Language = data2.language
          self.date_format = data2.dateFormat


        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    insert_system_users() {

      let self = this;
      const formData = new FormData();
      let url = "AddSystemRequestUsers";
      var array_obj = [];

      // 1 => مدیریت واحد
      // 2 => مدیریت اجرایی
      // 3 => مدیریت
      array_obj.push({
        Id: this.unit_modir_id,
        UserId: this.unit_modir,
        UserName: this.unit_modir_name,
        UserType: 1
      });
      array_obj.push({
        Id: this.ejraii_modir_id,
        UserId: this.ejraii_modir,
        UserName: this.ejraii_modir_name,
        UserType: 2
      });
      array_obj.push({
        Id: this.modir_asli_id,
        UserId: this.modir_asli,
        UserName: this.modir_asli_name,
        UserType: 3
      });


      formData.append('input', JSON.stringify(array_obj));

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

      }).catch(function (error) {
        console.log(error);
      });

    },
    get_system_users() {

      let self = this;
      const formData = new FormData();
      let url = "GetSystemRequestUsers";

      axios.post(url, formData, {}).then((res) => {
        self.ejraii_modir_search = false;
        self.unit_modir_search = false;
        self.modir_asli_search = false;
        var unit = res.data.data.filter(x => x.userType == 1)[0];
        var ejraii = res.data.data.filter(x => x.userType == 2)[0];
        var asli = res.data.data.filter(x => x.userType == 3)[0];
        self.unit_modir_options.push(unit);
        self.ejraii_modir_options.push(ejraii);
        self.modir_asli_options.push(asli);

        self.unit_modir = unit.userId;
        self.ejraii_modir = ejraii.userId;
        self.modir_asli = asli.userId;

        self.unit_modir_name = unit.userName;
        self.ejraii_modir_name = ejraii.userName;
        self.modir_asli_name = asli.userName;

        self.unit_modir_id = unit.id;
        self.ejraii_modir_id = ejraii.id;
        self.modir_asli_id = asli.id;
        setTimeout(() =>
                self.ejraii_modir_search = true
            , 500);

        setTimeout(() =>
                self.unit_modir_search = true
            , 500);

        setTimeout(() =>
                self.modir_asli_search = true
            , 500);

      }).catch(function (error) {
        console.log(error);
      });

    },

    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();


      }).catch(function (error) {
        console.log(error);
      });

    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      // formData.append('id', this.selected_province);

      axios.post('GetSystemSettings', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data.forEach((val) => {
            if (val.valueType == 4) {
              val.value = JSON.parse(val.value.toString())
            }
            if (val.module == 2) {
              self.items_warehouse.push(val)
            }
            // if (val.module == 2) {
            //   self.items_product.push(val)
            // }
            if (val.module == 3 || val.module == 4) {
              self.items_accounting.push(val)
            }
            // if (val.module == 4) {
            //   self.items_accounting_groups.push(val)
            // }

          });
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_api_response_modals(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_data_numbering(item) {


      let self = this;

      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "UpdateSystemSetting";
      } else {
        url = "UpdateSystemSetting";

      }
      // var person = new Object();
      // person.groupName = self.name;
      formData.append('id', item.id)

      // console.log("json group"+ JSON.stringify(person));
      formData.append('Value', item.value);
      formData.append('PrefixOrLenght', item.prefixOrLenght);
      // formData.append('OperationSystems',  OperationSystems);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res)

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_groups() {
      var self = this;
      self.items_accounting_list = [];

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  var obj = {
                    label: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    id: val.id,
                    children: self.get_childrens(val.id, response.data.data)
                  }
                  self.items_accounting_list.push(obj);
                }

              });

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {
            label: val2.accountName, name_code: val2.accountName + " (" + val2.accountCode + ")",
            code: val2.accountCode, id: val2.id, nature: val2.nature,
            type: val2.type,
          }
          if (this.get_childrens(val2.id, list) == null) {
            obj.children = this.get_childrens(val2.id, list)
          }
          array.push(obj);
          // val2.inserted = true;

        }
      });
      if (array.length) {
        return array;

      } else {
        return null;

      }
    },


  }
}

</script>
<style>
.col-form-label {

  font-size: 11px !important;
}
</style>
